import 'css-chunksrc/client/scenes/optimizedGantt/wbsHeader/detailsViewSelector/styles.scss';export default {
  "detailsViewSelector": "_detailsViewSelector_rcixh_1",
  "toggleButton": "_toggleButton_rcixh_13",
  "pressed": "_pressed_rcixh_28"
};